export function resolveInternalHref(
  href: string,
  currentUrl: string,
): string | null {
  if (
    href.startsWith("#") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:")
  ) {
    return null;
  }

  const target = new URL(href, currentUrl);
  const current = new URL(currentUrl);
  if (target.origin !== current.origin) {
    return null;
  }

  return `${target.pathname}${target.search}${target.hash}`;
}
